@forward '~@frontrow/console/css/variables.scss';

.deleteFieldContainer {
  width: 20%;
}

.deleteField {
  width: 30%;
}
